module.exports = "/assets/066f61a9c754d5e70ee913abdebcdee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/K6.png
// module id = 1534
// module chunks = 0